<template>
	<div class="text-caption mb-3">
		<div class="grey--text text--darken-1 mb-1">La password deve contenere:</div>
		<div v-for="req in requirements" :key="req.key" class="d-flex align-center">
			<v-icon x-small class="mr-1" :color="req.test(password) ? 'success' : 'grey'">
				{{ req.test(password) ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle-outline' }}
			</v-icon>
			<span :class="req.test(password) ? 'success--text' : 'grey--text text--darken-1'">{{ req.label }}</span>
		</div>
	</div>
</template>

<script>
import { passwordRequirements } from './portalPasswordPolicy'

export default {
	name: 'PortalPasswordRequirements',
	props: {
		password: String,
		policy: Object
	},
	computed: {
		requirements() {
			return passwordRequirements(this.policy)
		}
	}
}
</script>
